(function () {
  function initAnimations(root) {
    var items = root.querySelectorAll('.lp-animate:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }

  function initSliders(root) {
    root.querySelectorAll('[data-lp-slider]').forEach(function (slider) {
      if (slider.dataset.ready) return;
      slider.dataset.ready = '1';
      var track = slider.querySelector('.lp-slider__track');
      var slides = track ? track.children : [];
      var dots = slider.querySelectorAll('.lp-slider__dot');
      if (!track || !slides.length) return;

      function step() { return slides[0].getBoundingClientRect().width + 12; }
      function current() { return Math.round(track.scrollLeft / step()); }
      function update() {
        var i = current();
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }

      var prev = slider.querySelector('.lp-slider__arrow--prev');
      var next = slider.querySelector('.lp-slider__arrow--next');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      dots.forEach(function (d, n) {
        d.addEventListener('click', function () { track.scrollTo({ left: n * step(), behavior: 'smooth' }); });
      });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  function initCompare(root) {
    root.querySelectorAll('[data-lp-compare]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var range = box.querySelector('input[type="range"]');
      if (!range) return;
      function set() { box.style.setProperty('--lp-pos', range.value + '%'); }
      range.addEventListener('input', set);
      set();
    });
  }

  function initGallery(root) {
    root.querySelectorAll('[data-lp-gallery]').forEach(function (gallery) {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = '1';
      var track = gallery.querySelector('[data-lp-track]');
      var thumbs = gallery.querySelectorAll('[data-lp-thumb]');
      var dots = gallery.querySelectorAll('.cp-dot');
      if (!track) return;
      var slides = track.children;

      function current() { return Math.round(track.scrollLeft / track.clientWidth); }
      function goTo(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }
      function sync() {
        var i = current();
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
        var active = thumbs[i];
        var rowEl = gallery.querySelector('.cp-thumbs__row');
        if (active && rowEl) {
          var left = active.offsetLeft - rowEl.clientWidth / 2 + active.clientWidth / 2;
          rowEl.scrollTo({ left: left, behavior: 'smooth' });
        }
      }
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { sync(); ticking = false; });
      }, { passive: true });
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { goTo(Number(thumb.dataset.index)); });
      });
      var prevMain = gallery.querySelector('[data-lp-prev]');
      var nextMain = gallery.querySelector('[data-lp-next]');
      if (prevMain) prevMain.addEventListener('click', function () { goTo(current() - 1); });
      if (nextMain) nextMain.addEventListener('click', function () { goTo(current() + 1); });
      gallery.lpGoToMedia = function (mediaId) {
        for (var n = 0; n < slides.length; n++) {
          if (slides[n].dataset.mediaId === String(mediaId)) { goTo(n); return; }
        }
      };
      var row = gallery.querySelector('.cp-thumbs__row');
      var prev = gallery.querySelector('.cp-thumbs__arrow--prev');
      var next = gallery.querySelector('.cp-thumbs__arrow--next');
      if (row && prev) prev.addEventListener('click', function () { row.scrollBy({ left: -120, behavior: 'smooth' }); });
      if (row && next) next.addEventListener('click', function () { row.scrollBy({ left: 120, behavior: 'smooth' }); });
    });
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'MXN';
    try {
      return '$ ' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) {
      return '$ ' + (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function setAtcLabel(atc, text) {
    var label = atc.querySelector("[data-cp-atc-label]");
    if (label) label.textContent = text; else atc.textContent = text;
  }

  function initVariants(root) {
    root.querySelectorAll('[data-cp-variants]').forEach(function (picker) {
      if (picker.dataset.ready) return;
      picker.dataset.ready = '1';
      var jsonEl = picker.querySelector('[data-cp-variants-json]');
      if (!jsonEl) return;
      var variants = JSON.parse(jsonEl.textContent);
      var section = picker.closest('.cp-wrapper') || document;
      var input = section.querySelector('[data-cp-variant-input]');
      var atc = section.querySelector('[data-cp-atc]');
      var price = section.querySelector('[data-cp-price]');
      var compare = section.querySelector('[data-cp-compare]');
      var save = section.querySelector('[data-cp-save]');
      var radios = picker.querySelectorAll('input[data-cp-opt]');

      function selected() {
        var values = [];
        picker.querySelectorAll('.cp-opt').forEach(function (fs, i) {
          var checked = fs.querySelector('input:checked');
          values[i] = checked ? checked.value : null;
        });
        return values;
      }

      function markAvailability(values) {
        radios.forEach(function (radio) {
          var idx = Number(radio.dataset.cpOpt);
          var test = values.slice();
          test[idx] = radio.value;
          var match = variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return o === test[i]; });
          });
          radio.parentElement.classList.toggle('is-unavailable', !match);
        });
      }

      function update() {
        var values = selected();
        picker.querySelectorAll('.cp-opt').forEach(function (fs, i) {
          var label = fs.querySelector('[data-cp-opt-label]');
          if (label) label.textContent = values[i] || '';
        });
        markAvailability(values);
        var variant = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === values[i]; });
        });
        if (!variant) {
          if (atc) { atc.disabled = true; setAtcLabel(atc, atc.dataset.soldOut); }
          return;
        }
        if (input) input.value = variant.id;
        if (atc) {
          atc.disabled = !variant.available;
          setAtcLabel(atc, variant.available ? atc.dataset.text : atc.dataset.soldOut);
        }
        if (price) price.textContent = formatMoney(variant.price);
        var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (compare) { compare.hidden = !hasCompare; if (hasCompare) compare.textContent = formatMoney(variant.compare_at_price); }
        if (save) {
          var saveWrap = save.parentElement;
          saveWrap.hidden = !hasCompare;
          if (hasCompare) save.textContent = formatMoney(variant.compare_at_price - variant.price);
        }
        var gallery = section.querySelector('[data-lp-gallery]');
        if (gallery && gallery.lpGoToMedia && variant.featured_media) {
          gallery.lpGoToMedia(variant.featured_media.id);
        }
        section.dispatchEvent(new CustomEvent('cp:variant', { detail: variant }));
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }

      radios.forEach(function (r) { r.addEventListener('change', update); });
      markAvailability(selected());
    });
  }

  function initBundles(root) {
    root.querySelectorAll('[data-cp-bundle]').forEach(function (bundle) {
      if (bundle.dataset.ready) return;
      bundle.dataset.ready = '1';
      var section = bundle.closest('.cp-wrapper') || document;
      var qtyInput = section.querySelector('[data-cp-qty-input]');
      var radios = bundle.querySelectorAll('[data-cp-offer]');

      function select() {
        radios.forEach(function (r) { r.closest('.cp-offer').classList.toggle('is-selected', r.checked); });
        var checked = bundle.querySelector('[data-cp-offer]:checked');
        if (qtyInput && checked) qtyInput.value = checked.value;
        var atcPrice = section.querySelector("[data-cp-atc-price]");
        if (atcPrice && checked) { var tot = checked.closest(".cp-offer").querySelector("[data-o-total]"); if (tot) atcPrice.textContent = tot.textContent; }
      }
      radios.forEach(function (r) { r.addEventListener('change', select); });

      section.addEventListener('cp:variant', function (e) {
        var v = e.detail;
        bundle.querySelectorAll('.cp-offer').forEach(function (offer) {
          var qty = Number(offer.dataset.qty);
          var regular = v.price * qty;
          var total = offer.dataset.fixed === '1' ? Number(offer.dataset.total) : regular;
          var save = regular - total;
          offer.querySelector('[data-o-total]').textContent = formatMoney(total);
          var reg = offer.querySelector('[data-o-regular]');
          reg.textContent = formatMoney(regular);
          reg.hidden = save <= 0;
          offer.querySelector('[data-o-save-wrap]').hidden = save <= 0;
          offer.querySelector('[data-o-save]').textContent = formatMoney(save);
        });
      });
      select();
    });
  }

  function initVideos(root) {
    var videos = root.querySelectorAll('.lp-section video[autoplay]');
    if (!videos.length) return;
    videos.forEach(function (v) { v.muted = true; v.playsInline = true; });
    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) { var p = v.play(); if (p) p.catch(function () {}); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          var p = v.play();
          if (p) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.25 });
    videos.forEach(function (v) {
      if (v.dataset.lpObserved) return;
      v.dataset.lpObserved = '1';
      io.observe(v);
    });
  }

  function initPairs(root) {
    root.querySelectorAll('[data-cp-pairs]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var section = box.closest('.cp-wrapper') || document;
      var variants = JSON.parse(box.querySelector('[data-cp-pairs-json]').textContent);
      var form = section.querySelector('.cp-product-form');
      var atc = section.querySelector('[data-cp-atc]');
      var atcPrice = section.querySelector('[data-cp-atc-price]');
      var radios = box.querySelectorAll('[data-cp-pairs-offer]');

      function selectedOffer() { return box.querySelector('.cp-pairs__offer.is-selected'); }
      function update() {
        radios.forEach(function (r) { r.closest('.cp-pairs__offer').classList.toggle('is-selected', r.checked); });
        var offer = selectedOffer();
        if (atcPrice && offer) atcPrice.textContent = offer.querySelector('[data-o-total]').textContent;
      }
      function slotVariant(slot) {
        var vals = [];
        slot.querySelectorAll('[data-cp-slot-opt]').forEach(function (sel) { vals[Number(sel.dataset.cpSlotOpt)] = sel.value; });
        return variants.find(function (v) { return v.options.every(function (o, i) { return o === vals[i]; }); });
      }
      var gallery = section.querySelector('[data-lp-gallery]');
      function showColor(slot) {
        if (!slot) return;
        var colorSel = slot.querySelector('[data-cp-slot-opt="0"]');
        if (!colorSel) return;
        var v = variants.find(function (x) { return x.options[0] === colorSel.value && x.featured_media; });
        if (!v) return;
        if (gallery && gallery.lpGoToMedia) gallery.lpGoToMedia(v.featured_media.id);
        var offer = slot.closest('.cp-pairs__offer');
        var idx = Array.prototype.indexOf.call(offer.querySelectorAll('[data-cp-slot]'), slot);
        var img = offer.querySelectorAll('[data-cp-offer-thumbs] img')[idx];
        var src = v.featured_image && v.featured_image.src;
        if (img && src) {
          img.removeAttribute('srcset');
          img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        }
      }
      box.querySelectorAll('[data-cp-slot-opt="0"]').forEach(function (sel) {
        sel.addEventListener('change', function () { showColor(sel.closest('[data-cp-slot]')); });
      });
      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          update();
          var offer = selectedOffer();
          if (offer) showColor(offer.querySelector('[data-cp-slot]'));
        });
      });
      update();

      if (!form) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var offer = selectedOffer();
        if (!offer) return;
        var counts = {};
        var missing = false;
        offer.querySelectorAll('[data-cp-slot]').forEach(function (slot) {
          var v = slotVariant(slot);
          if (!v || !v.available) { missing = true; return; }
          counts[v.id] = (counts[v.id] || 0) + 1;
        });
        if (missing) { alert('Esa combinación de color y talla no está disponible.'); return; }
        var items = Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
        if (atc) atc.disabled = true;
        fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () { window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart'; })
          .catch(function () { if (atc) atc.disabled = false; alert('No se pudo añadir al carrito. Inténtalo de nuevo.'); });
      });
    });
  }

  function init(root) {
    root = root || document;
    initVideos(root);
    initAnimations(root);
    initSliders(root);
    initCompare(root);
    initGallery(root);
    initVariants(root);
    initBundles(root);
    initPairs(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
